module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('InnerMenu', {
    attrs: {
      "menu": _vm.menu
    }
  }, [_c('LoadingSpinner', {
    attrs: {
      "showContent": _vm.isReady && !_vm.isLoading,
      "size": 100
    }
  }, [(_vm.isError) ? _c('Infotext', {
    attrs: {
      "text": "Ошибка"
    }
  }, [_c('Button', {
    attrs: {
      "bordered": true,
      "autowidth": true
    },
    on: {
      "click": _vm.closeMessages
    }
  }, [_vm._v("Закрыть")])], 1) : [_c('SelectCount', {
    attrs: {
      "text": "Количество сообщений",
      "options": _vm.notificationsLimits,
      "value": _vm.notificationsLimit,
      "bottom": true
    },
    on: {
      "change": _vm.notificationsLimitChange
    }
  }), _c('router-view', {
    attrs: {
      "notifications": _vm.notifications
    },
    on: {
      "postData": _vm.postData
    }
  })]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c42acee","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/notification/Index.vue
// module id = b1cd25c3705f3441b544
// module chunks = 68